import { frequentlyBoughtTogether } from 'instantsearch.js/es/widgets';
import { algoliaAppId, algoliaApiKey, productSearchIndex } from '../variables'
import { productHit } from '../templates'
import { algoliasearch } from 'algoliasearch'

const product = document.querySelector('.s-product')
if (product) {
  const recommendClient = algoliasearch(algoliaAppId, algoliaApiKey)
  const currentObjectID = product.getAttribute('data-id')

  frequentlyBoughtTogether({
    container: '.s-product__recommend',
    recommendClient,
    indexName: productSearchIndex,
    objectIDs: [currentObjectID],
    view: (renderOptions) => {
      const { html, items } = renderOptions

      return html`
        <div class="grid">
          ${items.map((item) => productHit(item))}
        </div>
      `
    },
  })
}
